import Vue from 'vue'
import VueI18n from 'vue-i18n'

import serviceMessages from 'brave-services/i18n/en.json'
import contactMessages from 'brave-contact/i18n/en.json'
import companyMessages from 'brave-company/i18n/en.json'

export default function ({messages}) {
  Vue.use(VueI18n)
  let englishStrings = messages.en
  englishStrings = Object.assign(
    englishStrings,
    serviceMessages,
    contactMessages,
    companyMessages
  )

  messages.en = englishStrings

  return new VueI18n({
    locale: 'en',
    messages
  })
}